import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Companies from './pages/Companies';
import CompanyDetail from './pages/CompanyDetail';
import MGT7A from './pages/MGT7A';
import GST from './pages/GST';
import IEC from './pages/IEC';
import Suppliers from './pages/Suppliers';
import './App.css';
import Icegate from './pages/Icegate';
import EmailCampaigns from './pages/EmailCampaigns';
import CampaignDetail from './pages/CampaignDetail';


function ProtectedRoute({ children, perm }) {
  const { user, can, loading } = useAuth();
  if (loading) return <div className="page-loading"><div className="spinner" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (perm && !can(perm)) return (
    <div className="page">
      <div className="page-error">🔒 Access Denied — you don't have permission for this section.</div>
    </div>
  );
  return children;
}

function AppLayout() {
  const { user } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  if (!user) return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );

  return (
    <div className="app-layout">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="app-main">
        <header className="topbar">
          <button className="menu-btn" onClick={() => setSidebarOpen(o => !o)}>☰</button>
          <div className="topbar-title">Glazing Genius Dashboard</div>
          <div className="topbar-badge">Oracle DB Connected</div>
        </header>
        <main className="app-content">
          <Routes>
            <Route path="/"                    element={<ProtectedRoute perm="dashboard"><Dashboard /></ProtectedRoute>} />
            <Route path="/companies"           element={<ProtectedRoute perm="dashboard"><Companies /></ProtectedRoute>} />
            <Route path="/companies/:cin"      element={<ProtectedRoute perm="dashboard"><CompanyDetail /></ProtectedRoute>} />
            <Route path="/mgt7a"               element={<ProtectedRoute perm="mgt7a"><MGT7A /></ProtectedRoute>} />
            <Route path="/gst"                 element={<ProtectedRoute perm="gst"><GST /></ProtectedRoute>} />
            <Route path="/iec"                 element={<ProtectedRoute perm="iec"><IEC /></ProtectedRoute>} />
            <Route path="/suppliers"           element={<ProtectedRoute perm="dashboard"><Suppliers /></ProtectedRoute>} />
            <Route path="/login"               element={<Navigate to="/" replace />} />
            <Route path="*"                    element={<Navigate to="/" replace />} />
            <Route path="/icegate" element={<ProtectedRoute perm="iec"><Icegate /></ProtectedRoute>} />
            <Route path="/campaigns"     element={<ProtectedRoute perm="campaigns"><EmailCampaigns /></ProtectedRoute>} />
            <Route path="/campaigns/:id" element={<ProtectedRoute perm="campaigns"><CampaignDetail /></ProtectedRoute>} />
          </Routes>
        </main>
      </div>
    </div>
  );
}

export default function App() {
  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
    };
    document.addEventListener('contextmenu', handleContextMenu);
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppLayout />
      </BrowserRouter>
    </AuthProvider>
  );
}
